export default __webpack_public_path__ + "static/hero-mobile-7bd2c659f5ebdb8384a1fb0d321a6c04.png";